module.exports = __webpack_public_path__ + "assets/img/footer-blob-mid.4bb7895d.webp";